import axios from "axios";
import { Check } from "./types";

export const saveOutstandingCheckLedgerNote = async (user: string, note: string, check: Check) => {
  const { referenceNumber = "", ledgerName = "" } = check;
  if (!ledgerName || !note) return;

  const noteWithPrependedUser = `Follow up by ${user} regarding outstanding check # ${referenceNumber}: ${note}`;

  await axios.post("/proxy/api/ledgers/addLedgerNote", {
    ledgerName,
    note: noteWithPrependedUser
  });
};
